import { useV2 } from '@/hooks/useV2';
import MediaPlayer from '@/components/media/MediaPlayer';
import { OptimizedVideo } from '@/components/OptimizedVideo';

type Mode = 'lite' | 'full';

type Props = {
  mode: Mode;
  provider?: 'cloudinary' | 'none';
  cloudPublicId?: string;
  posterPublicId?: string;
  className?: string;
  autoOnVisible?: boolean;
  externalVideoRef?: React.RefObject<HTMLVideoElement>;
  onPlay?: () => void;
  onError?: () => void;
};

const CLOUD = import.meta.env.VITE_CLOUDINARY_CLOUD_NAME || 'yldsocialvideos';
const BASE = `https://res.cloudinary.com/${CLOUD}`;

export default function SmartMediaPlayer(p: Props) {
  const v2 = useV2();

  if (!v2) {
    // Legacy stable path
    const pid = p.cloudPublicId ?? '';
    const base = 'https://res.cloudinary.com/yldsocialvideos';
    const src = pid ? `${base}/video/upload/f_mp4,q_auto:eco/${pid}.mp4` : '';
    const poster = pid ? `${base}/video/upload/so_0,q_70/${pid}.jpg` : '/img/poster-fallback.svg';
    
    return (
      <OptimizedVideo
        src={src}
        poster={poster}
        className={p.className}
        autoPlay={p.mode === 'full' && p.autoOnVisible}
        muted
        loop
        controls
        onPlay={p.onPlay}
        onError={p.onError}
      />
    );
  }

  // V2 path
  return (
    <MediaPlayer
      mode={p.mode}
      provider={p.provider ?? 'cloudinary'}
      cloudPublicId={p.cloudPublicId}
      posterPublicId={p.posterPublicId}
      className={p.className}
      onPlay={p.onPlay}
      onError={p.onError}
    />
  );
}
